import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { HttpData } from "../../../../Core";

export default function AdditionInOrderModalCreate({ jwt, show, onHide, onCreated }) {

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [value, setValue] = useState('');
    const [coefficientValue, setCoefficientValue] = useState(1);
    const [math, setMath] = useState(1);
    const [freeLimit, setFreeLimit] = useState('');

    const onSubmit = async (e) => {
        e.preventDefault();

        const requestData = {
            name: name,
            description: description,
            value: +value,
            math: +math,
            coefficientValue: +coefficientValue,
            freeLimit: math == 5 && freeLimit ? +freeLimit : -1
        };

        const response = await HttpData('/api/v1/calculateOrderCost/orders/additions', 'POST', jwt, requestData);

        if (response.statusSuccessful)
            onCreated(response.data);
        else alert(`Не получилось создать: ${response.error}`)
    }

    return <Modal show={show} onHide={onHide}>
        <Form onSubmit={onSubmit}>
            <Modal.Header closeButton>
                <Modal.Title>Создание допика.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>Название</Form.Label>
                    <Form.Control
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Описание</Form.Label>
                    <Form.Control
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Значение</Form.Label>
                    <Form.Control
                        required
                        type="number"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Коэффициент</Form.Label>
                    <Form.Control
                        required
                        type="number"
                        value={coefficientValue}
                        onChange={(e) => setCoefficientValue(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Тип значения</Form.Label>
                    <Form.Select
                        value={math}
                        onChange={(e) => setMath(e.target.value)}
                    >
                        <option value={1}>Значение в ₽</option>
                        <option value={2}>Значение в %</option>
                        <option value={3}>Скидка в ₽</option>
                        <option value={4}>Скидка в %</option>
                        <option value={5}>Значение в шт</option>
                    </Form.Select>
                </Form.Group>
                {math == 5 && (
                    <Form.Group className="mb-3">
                        <Form.Label>1 шт бесплатно от</Form.Label>
                        <Form.Control
                            type="number"
                            value={freeLimit}
                            onChange={(e) => setFreeLimit(e.target.value)}
                            placeholder="Введите количество рублей"
                        />
                        <Form.Text className="text-muted">
                            Количество рублей, с которого идёт один экземпляр бесплатно
                        </Form.Text>
                    </Form.Group>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Отмена</Button>
                <Button variant="success" type="submit">Создать</Button>
            </Modal.Footer>
        </Form>
    </Modal>
}
